let appVersion = '0.0.0-development-SNAPSHOT'

export const setHostAppVersion = (version: string) => {
  appVersion = version
  console.log(`Host Application version: ${version}`)
}

export const getHostAppVersion = () => appVersion
